import { CommonModule } from "@angular/common";
import {} from "@angular/material";
import { MatToolbarModule } from "@angular/material/toolbar";
import { NgModule } from "@angular/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatStepperModule } from "@angular/material/stepper";
import { RxReactiveFormsModule } from "@rxweb/reactive-form-validators";
import { MatSliderModule } from "@angular/material/slider";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatGridListModule } from "@angular/material/grid-list";
import { DragDropModule} from '@angular/cdk/drag-drop'; 
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatMenuModule} from '@angular/material/menu'; 
import { MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatTableModule } from "@angular/material/table";
import { MatAutocompleteModule  } from "@angular/material/autocomplete";
import { MatSelectModule } from "@angular/material/select";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { MatCheckboxModule  } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatListModule  } from "@angular/material/list";
import { MatSidenavModule} from '@angular/material/sidenav'; 
import { MatTabsModule } from "@angular/material/tabs";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule as MatSnackBarModule } from "@angular/material/snack-bar";
import {MatRadioModule as MatRadioModule} from '@angular/material/radio';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import { MatTooltipModule as MatTooltipModule } from "@angular/material/tooltip";
@NgModule({
  imports: [
    MatAutocompleteModule,
    CommonModule,
    MatMenuModule,
    MatSlideToggleModule,
    NgxMaterialTimepickerModule,
    MatCheckboxModule,
    MatSelectModule,
    MatToolbarModule,
    DragDropModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    MatAutocompleteModule,
    RxReactiveFormsModule,
    MatSliderModule,
    MatSnackBarModule,
    MatTabsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatToolbarModule,
    MatGridListModule,
    MatDialogModule,
    MatTableModule,
    MatPaginatorModule,
    MatListModule,
    MatSidenavModule,
    MatRadioModule,
    AutocompleteLibModule
  ],
  exports: [
    CommonModule,
    MatMenuModule,
    NgxMaterialTimepickerModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatToolbarModule,
    MatCheckboxModule,
    DragDropModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatStepperModule,
    RxReactiveFormsModule,
    MatSliderModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatInputModule,
    MatToolbarModule,
    MatGridListModule,
    MatDialogModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatListModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatRadioModule
  ],
  providers: [    {provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
  {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 2500}}
],
  declarations: [
  ],
})
export class MaterialModule {}
